export default __webpack_public_path__ + "static/media/packageRepacking.717f5f8a.svg";